import React from 'react';
import { Option } from '../Inputs/Dropdown';
import icons from '../Icon/components';
import Dropdown from '../Dropdown';
import TEST_ID from './DetailsActionList.testid';

const text = {
  label: 'Opties',
};
type DetailsActionListOption = {
  icon?: keyof typeof icons;
  label: string;
  onClick: () => void;
  key: string;
  type?: 'DELETE' | null;
};
type Props = {
  options: Array<DetailsActionListOption>;
};
const DetailsActionList = ({ options }: Props) => {
  const dropdownOptions: Array<Option> = options.map(option => ({
    icon: option.icon,
    label: option.label,
    key: option.key,
    payload: option.onClick,
    type: option.type === 'DELETE' ? 'DANGER' : null,
  }));

  return (
    <div>
      <Dropdown
        dataTestId={TEST_ID.TOGGLE_BUTTON}
        withDefaultFirstOption={false}
        placeholder={text.label}
        appearance="outline"
        options={dropdownOptions}
        onChange={({ option }) => {
          option.payload();
        }}
      />
    </div>
  );
};

export default DetailsActionList;
